module.exports = __webpack_public_path__ + "media/images/member-database-flow-a334f1374fb1bcb77e6de540dce7c9c7.png";